import { Injectable } from "@angular/core";
import { Platform, NavController } from "ionic-angular";
import { AuthenticationService } from "../../core/authentication/authentication.service";
import { Observable, BehaviorSubject } from "rxjs";
import { AuthenticationStorage } from "../../core/authentication/authentication-storage.service";
import { UserStatus } from "../../core/data/user/user.model";
import { distinctUntilChanged, combineLatest } from "rxjs/operators";
import { UserService } from "../../user/user.service";

@Injectable()
export class NavigationService {
  setRoot(component: any): any {
    throw new Error("Method not implemented.");
  }

  public platformUsed$: Observable<string>;
  public platformUsedSubject$: BehaviorSubject<string> = new BehaviorSubject('');

  public currentRoute: string;
  public currentUserRole: string;
  private goToCongratsPage: boolean = false;
  private goToWelcomePage: boolean = false;
  public nav: NavController;

  private routes = {
    // intro: 'Intro',
    home: 'home',
    login: 'login',
    dashboard: 'dashboard',
    change_password: 'change-password',
    registration: 'registration',
    verification: 'verification',
    group_invitation: 'group-invitation',
    group_welcome: 'group-welcome',
    recover_password: 'recover-password',
    subscriptions: 'subscriptions',
    
  };

  constructor(
    public auth: AuthenticationService,
    public authStorage: AuthenticationStorage,
    public userService: UserService,
    public plt: Platform
  ) {
    this.platformUsed$ = this.platformUsedSubject$.asObservable().pipe();
  }

  // checkPlatformUsed() {
  //   if (this.plt.is('ios')) {
  //     this.platformUsedSubject$.next('ios');
  //   } else if (this.plt.is('android')) {
  //     this.platformUsedSubject$.next('android');
  //   } else {
  //     this.platformUsedSubject$.next('mobile-web');
  //   }
  // }

  public initNavigation(nav) {
    this.nav = nav;
    console.info('navigation enabled');

    //this.checkPlatformUsed();

    this.auth.userStatus$.pipe(
      combineLatest(
        this.userService.currentUser$.pipe(
          distinctUntilChanged((prev, next) => {
            if (prev === next) return true;
            if (!prev || !next) return false;
            return !(prev._id !== next._id)
          }),
        ),
      ),
      distinctUntilChanged(),
    ).subscribe(([status, currentUser]) => {
      if (currentUser && currentUser.role)
        return this.checkCurrentRoute(status, currentUser.role);
      return this.checkCurrentRoute(status);
    });
  }



  public checkCurrentRoute(status?: UserStatus, role?) {
    console.info('[user status]', status, role);
    if (status === UserStatus.exists) return;
    switch (status) {
      case UserStatus.unlogged: return this.toLogin();
      case UserStatus.registered: return this.toVerification();
      case UserStatus.verified: return this.toCreateProfile();
      case UserStatus.completed: return this.toUserGroup();
      case UserStatus.associated:
        if (this.goToCongratsPage) {
          return this.toGroupContratulation();
        } else if (this.goToWelcomePage) {
          return this.toGroupWelcome();
        } else {
          return this.toDashBoard(role);
        }
      case UserStatus.logged:
        if (!role) return;
        return this.toDashBoard(role);
      default: return this.toLogin();
    }
  }

  public toLogin() {
    return this.replace('Intro');
  }

  // public initialDashboard(){
  //   return this.push('dashboard');
  // }

  public toDashBoard(role?, force = false, groupInfo?) {
    if (groupInfo) {
      this.userService.updateUser({ activeGroup: { id: groupInfo.groupId, name: groupInfo.groupName } });
      this.userService.updateUserListByGroup(groupInfo.groupId);
    }
    if (!role) role = this.userService.getCurrentUser().role;

    if (role === 'patient') return this.replace('home-patient', force);
    return this.replace('home', force);
  }
  /*se l'utente è un paziente alla ricezione della notifica sarà reindirizzato ai reminders */
  public manageNotificationsRedirect(role?, force = false, groupInfo?) {
    if (groupInfo) {
      this.userService.updateUser({ activeGroup: { id: groupInfo.groupId, name: groupInfo.groupName } });
      this.userService.updateUserListByGroup(groupInfo.groupId);
    }
    if (!role) role = this.userService.getCurrentUser().role;
    if (role === 'patient') return this.replace('reminder-patient', force);
    return this.replace('home', force);
  }

  public prevPage() {
    return this.nav.pop();
  }
  public toRegistration() {
    return this.push('registration');
  }
  public toVerification() {
    return this.push('verification');
  }
  public toCreateProfile() {
    return this.push('profile_creation');
  }
  public toUserGroup() {
    return this.push('group');
  }
  public toGroupContratulation() {
    return this.push('group_congratulation');
  }
  public toGroupWelcome() {
    return this.push('group_welcome');
  }
  public toGroupInvitationPatient() {
    return this.push('group_invitation_patient');
  }
  public toGroupInvitationCollaborator() {
    return this.push('group_invitation_collaborator');
  }
  public toOfflinePage(){
    return this.replace('offline', true);
  }

  public setCongratulation() {
    this.goToCongratsPage = true;
  }
  public setWelcome() {
    this.goToWelcomePage = true;
  }
  public unSetCongratulation() {
    this.goToCongratsPage = false;
  }
  public unSetWelcome() {
    this.goToWelcomePage = false;
  }

  public push(route: string) {
    const active = this.nav && this.nav.getActive();
    if (!active || (active.id !== route) && route !== this.currentRoute) {
      this.currentRoute = route;
      return this.nav.push(this.routes[route]);
    }
  }

  public pop(route?) {
    if (route) {
      this.currentRoute = route;
      return this.nav.popTo(route);
    }
    return this.nav.pop();
  }

  public replace(route: string, force = false) {
    const active = this.nav && this.nav.getActive();
    if (force || (!active || (active.id !== route) && route !== this.currentRoute)) {
      this.currentRoute = route;
      this.nav.setRoot(route);
      this.nav.popToRoot();
    }
  }
  public replaceToPage(route: string){
    this.nav.setRoot(route);
    this.nav.popToRoot();
  }

  public popToRoot(){
    return this.nav.popToRoot();
  }


}


// WEBPACK FOOTER //
// ./src/app/services/navigation/navigation.service.ts